import React from 'react'
import { Box, Fab, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import ConditionsList from './conditionsList'
import { useDispatch } from 'react-redux'
import { addedWhereConditionAction } from '../../../store/pages/common/query'
import { styled } from '@mui/material/styles'

const ButtonContainer = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(15),
  marginTop: theme.spacing(1),
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center'
}))

export default function Conditions () {
  const dispatch = useDispatch()

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Conditions</Typography>
        <ButtonContainer>
          <Fab
            data-testid='button-add'
            size="small"
            color="primary"
            aria-label="add"
            onClick={() => dispatch(addedWhereConditionAction)}
          >
            <AddIcon />
          </Fab>
        </ButtonContainer>
      </Box>

      <Box mt={2}>
        <ConditionsList />
      </Box>
    </Box>
  )
}
